
export default function About() {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/d04e820c57a91e186d740e2dee9356e2.jpg"
              alt="OK TREND FIĽAKOVO Company"
              className="rounded-2xl shadow-2xl w-full h-auto object-cover object-top"
            />
          </div>
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              About OK TREND FIĽAKOVO
            </h2>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              OK TREND FIĽAKOVO, s.r.o. is a leading software development company based in Slovakia, dedicated to creating innovative applications that enhance digital security and user experience. Our mission is to provide cutting-edge solutions that protect your online privacy and make the internet a safer place for everyone.
            </p>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              Our flagship VPN application represents years of research and development in cybersecurity technology. We combine advanced encryption protocols with user-friendly design to deliver a VPN solution that doesn't compromise on security or performance. Every feature is carefully crafted to ensure your data remains private and your connection stays fast and reliable.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Located in Fiľakovo, Slovakia, we serve customers worldwide with our commitment to excellence, innovation, and customer satisfaction. Our team of experienced developers and security experts works tirelessly to keep you protected in an ever-evolving digital landscape.
            </p>
            <div className="bg-blue-50 p-6 rounded-xl">
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                Our Location
              </h3>
              <div className="space-y-2 text-gray-700">
                <p className="flex items-start">
                  <i className="ri-map-pin-line text-blue-600 mr-3 mt-1"></i>
                  <span>1117/66 Obrancov mieru, Fiľakovo, 986 01, Slovakia</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
